type Props = {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

export default function Checkbox({
  label,
  checked,
  onChange
}: Props) {
  return (
    <label className="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4"
      />

      <span>{label}</span>
    </label>
  )
}